"use client";

import { useEffect, useState } from "react";
import Header from "./components/header";
import Main from "./components/main";
import Sidebar from "./components/sidebar";
import type { SidebarLabel } from "./components/sidebar";
import { useAuth } from "./hooks/useAuth";
import TeacherLogin from "./components/teacherLogin";
import MainLogin from "./components/mainLogin";

export default function Home() {
  const [selectedLabel, setSelectedLabel] = useState<SidebarLabel>(
    "คลังบทเรียนต้นแบบ"
  );
  const [isTemplateEditorVisible, setIsTemplateEditorVisible] = useState(false);
  const [showTeacherLoginScreen, setShowTeacherLoginScreen] = useState(false);
  const [hasLocalStorageUser, setHasLocalStorageUser] = useState(false);
  const { authStatus, user, login, logout } = useAuth();

  useEffect(() => {
    const syncLocalStorageUser = () => {
      const raw = localStorage.getItem("user");
      setHasLocalStorageUser(Boolean(raw));
    };

    syncLocalStorageUser();
    window.addEventListener("storage", syncLocalStorageUser);
    window.addEventListener("user-storage-changed", syncLocalStorageUser);

    return () => {
      window.removeEventListener("storage", syncLocalStorageUser);
      window.removeEventListener("user-storage-changed", syncLocalStorageUser);
    };
  }, []);

  useEffect(() => {
    if (authStatus !== "unauthenticated") {
      setShowTeacherLoginScreen(false);
    }
  }, [authStatus]);

  useEffect(() => {
    if (!hasLocalStorageUser) {
      setShowTeacherLoginScreen(false);
    }
  }, [hasLocalStorageUser]);

  if (authStatus === "checking") {
    return (
      <div className="fixed inset-0 z-90 flex min-h-screen w-full items-center justify-center bg-white">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-indigo-500 border-t-transparent"></div>
      </div>
    );
  }

  if (authStatus === "unauthenticated") {
    if (showTeacherLoginScreen) {
      return (
        <TeacherLogin
          mode="fullscreen"
          status={authStatus}
          user={user}
          onLogin={login}
          onLogout={logout}
          onBackToMainLogin={() => setShowTeacherLoginScreen(false)}
        />
      );
    }

    return <MainLogin onTeacherLoginClick={() => setShowTeacherLoginScreen(true)} />;
  }

  return (
    <div className="min-h-screen bg-[#f4f3ea] text-neutral-800">
      <Header authStatus={authStatus} user={user} onLogin={login} onLogout={logout} />
      <div className="flex min-h-[calc(100vh-64px)]">
        <Sidebar selectedLabel={selectedLabel} onSelect={setSelectedLabel} />
        <Main
          selectedLabel={selectedLabel}
          onTemplateEditorVisibilityChange={setIsTemplateEditorVisible}
          onNavigateToLabel={setSelectedLabel}
        />
      </div>
    </div>
  );
}
